module.exports = __webpack_public_path__ + "static/WEDDING E&M-302-a4d0b3377e952219a50e6eba8953667a.jpg";